import React from "react";
import { Component } from "react";
import { connect } from "react-redux";
import actions from "actions";
import CourseMaterialsList from "../../../components/Admin/StudyGroups/CourseMaterials/CourseMaterialsList";
import Toolbar from "../../../components/Admin/StudyGroups/CourseMaterials/Toolbar";
import constants from "constants";
import { clearCourseMaterials } from "../../../actions/studygroups";

const {
  getCourseMaterials,
  showDeleteCourseMaterialsConfirmationModal,
  showModal,
} = actions;
const { MODAL_TYPE_COURSE_MATERIAL } = constants;

class CourseMaterials extends Component {
  constructor(props) {
    super(props);

    this.state = {
      course_materials_ids: [],
      page: props.page || 1,
      query: {
        search: "",
      },
    };
  }

  componentDidMount() {
    this.handleGetCourseMaterials();
  }

  componentWillUnmount() {
    this.props.clearCourseMaterials();
  }

  handleGetCourseMaterials = () => {
    const { loadCourseMaterials, per_page, params } = this.props;
    const { query, page } = this.state;

    loadCourseMaterials(params.id, { page, per_page, query });
  };

  handleCourseMaterialModal = (material = {}) => {
    const { showModal, studygroup } = this.props;

    showModal(MODAL_TYPE_COURSE_MATERIAL, {
      material: {
        ...material,
        group_id: studygroup.id,
      },
    });
  };

  deleteCourseMaterials = () => {
    const { deleteCourseMaterialsModal } = this.props;
    const { course_materials_ids } = this.state;

    deleteCourseMaterialsModal(course_materials_ids);
  };

  changeQuery = (query, timeout = 500) => {
    this.setState({ query }, () => {
      if (this.timer) {
        clearTimeout(this.timer);
      }

      console.log(this.state.query);

      this.timer = setTimeout(this.handleGetCourseMaterials, timeout);
    });
  };

  onChangeQuery = (field, value) => {
    const query = { ...this.state.query, ...{ [field]: value } };

    this.setState({ page: 1 }, () => {
      this.changeQuery(query);
    });
  };

  onChangePage = (page = 1) => {
    this.setState({ page }, this.handleGetCourseMaterials);
  };

  checkItem = (courseMaterialId) => {
    const { course_materials_ids } = this.state;
    const ids = _.assign(course_materials_ids);
    const index = course_materials_ids.indexOf(courseMaterialId);

    if (index === -1) {
      ids.push(courseMaterialId);
    } else {
      ids.splice(index, 1);
    }

    this.setState({ course_materials_ids: ids });
  };

  render() {
    const { count, total_pages, courseMaterials } = this.props;
    const { query, page, course_materials_ids } = this.state;

    return (
      <div>
        <Toolbar
          count={count}
          deleteCourseMaterials={this.deleteCourseMaterials}
          onChangeQuery={this.onChangeQuery}
          query={query}
          handleCourseMaterialModal={this.handleCourseMaterialModal}
        />
        <CourseMaterialsList
          courseMaterials={courseMaterials}
          editMaterial={this.handleCourseMaterialModal}
          checkItem={this.checkItem}
          checkedIds={course_materials_ids}
          paginationProps={{
            onChangePage: this.onChangePage,
            page,
            total_pages,
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  role: state.users.user.role,
  studygroup: state.studygroups.studygroup,
  courseMaterials: state.studygroups.courseMaterials.values,
  count: state.studygroups.courseMaterials.count,
  page: state.studygroups.courseMaterials.page,
  per_page: state.studygroups.courseMaterials.per_page,
  total_pages: state.studygroups.courseMaterials.total_pages,
  query: state.studygroups.courseMaterials.query,
});

const mapDispatchToProps = (dispatch) => ({
  loadCourseMaterials: (groupId, params) =>
    dispatch(getCourseMaterials(groupId, params)),
  deleteCourseMaterialsModal: (ids) =>
    dispatch(showDeleteCourseMaterialsConfirmationModal(ids)),
  showModal: (modalType, modalContentProps) =>
    dispatch(showModal(modalType, modalContentProps)),
  clearCourseMaterials: () => dispatch(clearCourseMaterials()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CourseMaterials);



// WEBPACK FOOTER //
// ./src/containers/Admin/StudyGroups/CourseMaterials.jsx